export const orderTypes = [
  { label: 'Bình Thường', value: 'normal' },
  { label: 'Mua trong event', value: 'sale_in_app' },
  { label: 'Được tài trợ', value: 'free_tier' }
];

export const orderStatus = [
  { label: 'Pending', value: 'pending' },
  { label: 'Completed', value: 'completed' },
  { label: 'Failed', value: 'failed' },
  { label: 'Canceled', value: 'canceled' },
  { label: 'Transferred', value: 'transferred' }
];

export const FromPlans = [
  { label: 'AiHub', value: 'ai_hub' },
  { label: 'AiStore', value: 'ai_store' },
  { label: 'AiReseller', value: 'ai_reseller' },
  { label: 'Add On', value: 'add_on' },
];

export const VatRequests = [
  { label: 'Yes', value: 'true' },
  { label: 'No', value: 'false' },
];

export const VatExports = [
  { label: 'Yes', value: 'true' },
  { label: 'No', value: 'false' },
];

export const ExportTypes = [
  { label: 'Công Ty', value: 'company' },
  { label: 'Cá Nhân', value: 'individual' },
];

export const ExportSources = [
  { label: 'AI Store', value: 'ai_store' },
  { label: 'AI Hub', value: 'ai_hub' },
  { label: 'AI Reseller', value: 'ai_reseller' },
];

export function exportOrdersToCSV(jsonData, export_type) {
  const data = jsonData.data;

  // Helper function to format date from timestamp to DD/MM/YYYY HH:MM
  const formatDateTime = (timestamp) => {
    const date = new Date(timestamp * 1000);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  // Define headers and rows in function scope to avoid no-undef
  let headers;
  let rows;

  // CSV headers
  if (export_type === 'orders_with_commission') {
    headers = [
      'Name',
      'Email',
      'Domain',
      'Plan Name',
      'Plan ID',
      'Status',
      'Code',
      'Commission',
      'DiscountCode',
      'Amount',
      'Created At'
    ];
    // CSV rows
    rows = data.map((item) => [
      item.created_by?.name || '', // Name from created_by
      item.created_by?.email || '', // Email from created_by
      item.from_domain || '', // Domain
      item.plan_name || '', // Plan Name
      item.plan_id || '', // Plan ID
      item.status || '', // Status
      item.code || '', // Code
      item.commission_amount || 0, // Commission
      item.discount_code?.code || '', // DiscountCode
      item.amount || 0, // Amount
      formatDateTime(item.created_at) // Created At in DD/MM/YYYY HH:MM format
    ]);
  } else {
    headers = [
      'Name',
      'Email',
      'Domain',
      'Plan Name',
      'Plan ID',
      'Status',
      'Code',
      'DiscountCode',
      'Amount',
      'Created At'
    ];
    // CSV rows
    rows = data.map((item) => [
      item.created_by?.name || '', // Name from created_by
      item.created_by?.email || '', // Email from created_by
      item.from_domain || '', // Domain
      item.plan_name || '', // Plan Name
      item.plan_id || '', // Plan ID
      item.status || '', // Status
      item.code || '', // Code
      item.discount_code?.code || '', // DiscountCode
      item.amount || 0, // Amount
      formatDateTime(item.created_at) // Created At in DD/MM/YYYY HH:MM format
    ]);
  }

  // Convert array to CSV string
  const csvContent = [headers.join(','), ...rows.map(row => row.map(String).join(','))].join('\n');
  
  // Generate filename with current timestamp
  const timestamp = Math.floor(Date.now() / 1000);
  const formattedDate = formatDateTime(timestamp).replaceAll("/", "_").replaceAll(":", "_").replaceAll(" ", "_");
  
  // Create a Blob and trigger download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', `orders_${formattedDate}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}